<script setup>
import { onMounted, ref } from 'vue'
import { useJobCategoryStore } from '@/stores/jobCategory'

const jobCategoryStore = useJobCategoryStore()

const props = defineProps({
  jobCategory: {
    type: Object,
    default: () => ({})
  }
})

onMounted(() => {
  jobCategoryStore.getAllJobCategories()
})

const jobCategory = ref({ ...props.jobCategory })

const errorMessage = ref('')

const emits = defineEmits(['close'])

const submit = async () => {
  errorMessage.value = ''
  if (!jobCategory.value.name) {
    errorMessage.value = 'שם קטגוריה נדרש'
    return
  }

  // בדוק אם כבר יש קטגוריה בשם זה
  const existingCategory = jobCategoryStore.jobCategories.find(
    (c) =>
      c.name?.trim()?.toLowerCase() === jobCategory.value.name.toLowerCase() &&
      c.id !== jobCategory.value.id
  )
  if (existingCategory) {
    errorMessage.value = 'כבר קיימת קטגוריה עם שם זה'
    return
  }

  const id = jobCategory.value.id
    ? await jobCategoryStore.updateJobCategory(jobCategory.value)
    : await jobCategoryStore.createJobCategory(jobCategory.value)

  emits('close', id)
}
</script>

<template>
  <form @submit.prevent="submit">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label for="name"> שם קטגוריה </label>
        <InputText id="name" v-model.trim="jobCategory.name" type="text" fluid autofocus />
        <Message v-if="errorMessage" severity="error" variant="simple" size="small">
          {{ errorMessage }}
        </Message>
      </div>

      <div class="flex gap-4">
        <Button fluid severity="secondary" outlined label="ביטול" @click="emits('close')" />
        <Button fluid label="שמירה" type="submit" :loading="jobCategoryStore.loading" />
      </div>
    </div>
  </form>
</template>
